import { DialogTitle, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {useForm} from "react-hook-form";
import { renomear } from '../../../services/documento/DocumentoService';
import useStyles from './styles';
import { useSnackbar } from 'notistack';

const RenomearDocumento = (props) => {
  const classes = useStyles();
  const { afterSubmit, open, onClose, idDocumento } = props;
  const { register, handleSubmit, errors } = useForm();
  const { enqueueSnackbar } = useSnackbar();

  const [form, setForm] = useState({ nome: '' });
  const handleChange = (event) => {
    const { name, value } = event.target
    setForm({ ...form, [name]: value })
  };

  const { nome } = form;

  const submit = async (event) => {
    try {
      await renomear(idDocumento, nome);
      enqueueSnackbar('Documento renomeado com sucesso', { variant: 'success' })
      afterSubmit();
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro renomear o documento', { variant: 'error' })
    }

    onClose();

  }

  return (
    <div>

      <Dialog fullWidth open={open} onClose={onClose}>
        <form onSubmit={handleSubmit(submit)}>
          <DialogTitle disableTypography>
            <IconButton className={classes.closeButton} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Typography className={classes.titulo}>Renomear Documento</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="nome"
                  InputLabelProps={{ shrink: true }}
                  value={nome}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  error={!!errors.nome}
                  helperText={errors.nome && errors.nome.message}
                  placeholder="Nome atual do documento"
                  inputRef={register({
                    required: 'Novo novo obrigatório'
                  })}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              onClick={onClose}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained">
              Salvar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {/* <ConviteSucesso open={openSucesso} onClose={() => setOpenSucesso(false)} /> */}
    </div>
  )

}

export default RenomearDocumento;

RenomearDocumento.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  idDocumento: PropTypes.number,
};
